import React from 'react';
import { translate } from '../Services/translation';

const ShareWishlistButton = ({ onClick }) => (
    <button onClick={onClick} className="wishlist-share__share-button">
        {' '}
        {translate('wishlist.sharebutton')}{' '}
    </button>
);

export default ShareWishlistButton;
